module.exports = __webpack_public_path__ + "static/img/customer.bb318889.png";